<template>
    <div id='invoice-detail-table'>
        <div>
            <table class="table table-sm table-bordered table-striped table-responsive-sm">
                <thead >
                    <tr>
                        <th class="table-header-text">No.ID</th>
                        <th class="table-header-text">Qty</th>
                        <th class="table-header-text">Nama Barang</th>
                        <th class="table-header-text">Keterangan</th>
                        <th class="table-header-text">Harga Satuan (Rp)</th>
                        <th class="table-header-text">Diskon</th>
                        <th class="table-header-text">Pajak</th>
                        <th class="table-header-text">Jumlah (Rp)</th>
                        <th class="table-header-text" v-if="!isIgnore">Action</th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-if="loadingTable === false && totalData == 0">
                        <td colspan="9" class="text-center">Data Not Available</td>
                    </tr>
                    <tr v-else-if="loadingTable === true">
                        <td colspan="9" class="text-center"><img src="~@/assets/images/load-button.gif"></td>
                    </tr>
                    <!-- <tr v-for="data in invoiceData" v-else-if="loadingTable === false && totalData != 0"> -->
                    <tr v-for="(data, index) in invoiceData.filter(item => !item.delete)" :key="index">
                        <td style="text-align: center;" >
                            {{isSplitByQty ? data.uniqueCode : data.groupCode}} 
                        </td>
                        <td  width='7%' style="text-align: center;" v-if="!data.isAdditionalItem">
                            {{data.qty}} Buah
                        </td>
                        <td  width='7%' style="text-align: center;" v-else>
                            <span :id="`qty-${index}`" :class="data.uniqueCode.split('-').includes('RU') ? '' : (isIgnore ? '' : 'editable')" :contenteditable="!data.uniqueCode.split('-').includes('RU') && !isIgnore" @keypress="onlyNumberInput" @blur="event => onDataChange(event, data.invoiceDetailId, index, 'qty')">
                                {{data.qty}}
                            </span>
                            Buah
                        </td>
                        <td width='13%'>
                            <span 
                                :id="`name-${index}`" 
                               :class="data.uniqueCode.split('-').includes('RU') ? '' : (isIgnore ? '' : 'editable')" 
                               :contenteditable="!data.uniqueCode.split('-').includes('RU') && !isIgnore"
                                @blur="event => onDataChange(event, data.invoiceDetailId,index, 'productName')"
                            >
                                {{data.productName}}
                            </span>
                        </td>
                        <td width='15%'>
                            <span :id="`keterangan-${index}`" :class="data.isAdditionalItem && !data.uniqueCode.split('-').includes('RU') ? (isIgnore ? '' : 'editable') : ''" :contenteditable="data.isAdditionalItem && !data.uniqueCode.split('-').includes('RU') && !isIgnore"  @blur="event => onDataChange(event, data.invoiceDetailId,index, 'descriptions')">
                                <span v-if="!data.isAdditionalItem" v-html="data.descriptions.replace(/(?:\r\n|\r|\n)/g, '<br>')"></span>
                                <span v-else>{{data.descriptions ? data.descriptions : '-'}}</span>
                            </span>
                            <span :id="`LP-${index}`"  v-if="data.orderCode && !data.isAdditionalItem">
                                <div v-html="data.orderCode"></div>
                            </span>
                        </td>
                        <td style="text-align: center;">
                            <span :id="`harga-satuan-${index}`" :class="data.uniqueCode.split('-').includes('RU') ? '' : (isIgnore ? '' : 'editable')" :contenteditable="!data.uniqueCode.split('-').includes('RU') && !isIgnore" @keypress="onlyNumberInput" @blur="event => onDataChange(event, data.invoiceDetailId, index, 'amount')">
                                {{formatPrice(data.amount)}}
                            </span>
                        </td>
                        <td style="text-align: center;">
                            <span :id="`diskon-${index}`" :class="data.uniqueCode.split('-').includes('RU') ? '' : (isIgnore ? '' : 'editable')" :contenteditable="!data.uniqueCode.split('-').includes('RU') && !isIgnore" @keypress="onlyNumberInput" @blur="event => onDataChange(event, data.invoiceDetailId,index, 'amountDiscount')">
                                {{formatPrice(data.amountDiscount)}}
                            </span>
                        </td>
                        <td style="text-align: center;">
                            {{formatPrice(data.amountTax)}}
                        </td>
                        <td style="text-align: center;">
                            <span :id="`jumlah-${index}`">
                                {{formatPrice(data.amountTotal)}}
                            </span>
                        </td>
                        <td width='18%' style="vertical-align: middle; text-align: center;" v-if="!isIgnore">
                            <div v-if="!data.isAdditionalItem">
                                <button class="btn btn-danger btn-sm mb-2" @click="modifyBillingDate(data.groupedIds)"
                                >
                                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                                        <path 
                                            d="M9 11L5 15M5 15L9 19M5 15H16C17.0609 15 18.0783 14.5786 18.8284 13.8284C19.5786 13.0783 20 12.0609 20 11C20 9.93913 19.5786 8.92172 18.8284 8.17157C18.0783 7.42143 17.0609 7 16 7H15" 
                                            stroke="white" 
                                            stroke-width="2" 
                                            stroke-linecap="round"
                                            stroke-linejoin="round"
                                        />
                                    </svg>
                                    Exclude / Modify Billing Cycle
                                </button>
                                <button class="btn btn-warning btn-md" @click="restoreDetail(data.groupedIds)"
                                >
                                    <i class="fa fa-history" aria-hidden="true"></i>
                                    Restore Details
                                </button>
                            </div>
                            <button class="btn btn-danger btn-sm mb-2 mt-2" @click="deleteRow(index)" v-if="data.isAdditionalItem">
                                <i class="fas fa-trash"></i>
                            </button>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
        <div id="wrapperr">
            <div id="c1" style="display: inline-flex;">
                <div style="margin-right: 10px;">
                    <select class="form-control form-control-sm" v-model="itemPerPage" @change="showPage(itemPerPage)">
                        <option value="10">10</option>
                        <option value="40">40</option>
                        <option value="80">80</option>
                    </select>
                </div>
                <div class="alignLeft total-data">
                        Total Data {{ totalData }} 
                </div>
            </div>
            <div id="c2">
                <div class="pagination p8 alignRight">
                    <ul>
                        <a class="is-active link" @click="toDataPage(parseInt(currentPage)-1)" v-if="currentPage != 1"><li>{{'<'}}</li></a>
                        <a class="page"><li>{{ currentPage }} of {{ totalPage }} page</li></a>
                        <a class="is-active link" @click="toDataPage(parseInt(currentPage)+1)" v-if="currentPage != totalPage"><li>{{'>'}}</li></a>
                    </ul>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

export default {
  name: 'InvoiceDetailTable',
  props : [
    'isIgnore',
    'invoiceData', 
    'totalData', 
    'currentPage', 
    'totalPage', 
    'onDataChange',
    'toDataPage',
    'showPage',
    'deleteRow',
    'setInvoiceDetailIdTobeExcluded',
    'setInvoiceDetailIdTobeRestored',
    'setIsExclude',
    'setIsRestoreAll',
    'loadingTable',
    'jurnalStatus',
    'isSplitByQty',
    ],
  data () {
    return {
      admin:"",
      permission:[],
      viewDashboard: false,
      viewOrder: false,
      viewReturn: false,
      viewProduct: false,
      viewPairing: false,
      viewReconcile: false,
      viewResolution: false,
      viewLessor: false,
      viewLessee: false,
      viewEmployee: false,
      editOrder: false,
      editReturn: false,
      editProduct: false,
      editPairing: false,
      editReconcile: false,
      editResolution: false,
      editLessor: false,
      editLessee: false,
      editEmployee: false,
      itemPerPage : 0,
    }
  },
  methods:{
    onlyNumberInput(data) {
        if(data.charCode != 44) {
            if(data.charCode < 48 || data.charCode > 57) {
                data.preventDefault()
            }
        } 
    },
    modifyBillingDate(groupedIds) {
        if(this.jurnalStatus == 'Pending' || this.jurnalStatus == 'On Progress') {
            $(`#modalDisableAction`).modal("show");
        }else {
            this.setInvoiceDetailIdTobeExcluded(groupedIds)
            this.setIsExclude(true)
            this.openModal('UpdateInvoiceBillingDate')
        }
    },
    restoreDetail(groupedIds) {
        if(this.jurnalStatus == 'Pending' || this.jurnalStatus == 'On Progress') {
            $(`#modalDisableAction`).modal("show");
        }else {
            this.setInvoiceDetailIdTobeRestored(groupedIds)
            this.setIsRestoreAll(false)
            this.openModal('RestoreInvoiceDetails')
        }
    },
    formatPrice(value) {
        let val = value  ? Number(value) : Number(0)
        const round = val.toString().split('.')[0]
        const decimal = val.toString().split('.')[1]

        let result = round.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
        result = decimal ? `${result},${decimal}` : `${result},00`
      
        return result
    },
    openModal(modalName) {
        $(`#modal${modalName}`).modal("show");
    }
  },
  created(){
    this.itemPerPage = this.$route.query.itemPerPage
    // this.getData()
    // this.admin = localStorage.getItem('admin_name')
    // this.cekLogin()
    // this.cekPermission()
  }
}
$(document).ready(function(){
  var self = this
});
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    .table-header-text {
        color: #2E3646;
        font-size: 16px;
        font-style: normal;
        font-weight: 700;
        line-height: 20px; /* 125% */
        letter-spacing: -0.016px;
        text-align: center;
    }

.editable:hover {
    text-decoration: underline;
}
.pagination{
padding: 0px 0;
}

.pagination ul{
margin: 0;
padding: 0;
list-style-type: none;
}

.pagination a{
display: inline-block;
padding: 1px 6px;
color: #222;
}

.p8 a{
background-color: #2797FB;
/*margin: auto 5px;*/
color: #fff;
/*font-weight: bold;*/
border: 1px solid #2797FB;
}

.p8 a:hover{
text-decoration: none;
}
.p8 a.page:hover{
text-decoration: none;
color: #fff;
}

.p8 .is-active{
background-color: #fff;
color: #2797FB;
}

.alignleft {
float: left;
}
.alignright {
float: right;
}

.pagg{
display: inline-flex;
overflow:auto;
}

.total-data{
padding: 11px 0px;
font-size: 14px;
color: #343A40;
}
#wrapperr{
  overflow:auto;
  margin: 5px 3px;
}

#c1{
 float:left;
}

#c2{
float: right;  
}

@media (max-width: 767px) {
  .nav-side-menu {
    position: relative;
    width: 100%;
    margin-bottom: 10px;
  }
  .nav-side-menu .toggle-btn {
    display: block;
    cursor: pointer;
    position: absolute;
    right: 10px;
    top: 10px;
    z-index: 10 !important;
    padding: 3px;
    background-color: #ffffff;
    color: #000;
    width: 40px;
    text-align: center;
  }
  .brand {
    text-align: left !important;
    font-size: 22px;
    padding-left: 20px;
    line-height: 50px !important;
  }
}
@media (min-width: 767px) {
  .nav-side-menu .menu-list .menu-content {
    display: block;
  }
}
@media (max-width: 573px){
  .mobile-div{
    padding: 2px 0px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Invoicing/CustomComponent/InvoiceDetailTable.vue